import type { Bookmaker, MatchResponse, QuizAnswers } from './types';

export class ApiClient {
  constructor(private readonly baseUrl: string) {}

  async getBookmakers(signal?: AbortSignal): Promise<Bookmaker[]> {
    const res = await fetch(`${this.baseUrl}/bookmakers`, { signal });
    if (!res.ok) throw new Error(`bookmakers: ${res.status}`);
    return res.json();
  }

  async match(answers: QuizAnswers, signal?: AbortSignal): Promise<MatchResponse> {
    const res = await fetch(`${this.baseUrl}/match`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sports: answers.sports,
        betting_style: answers.bettingStyle,
        stake_band: answers.stakeBand,
        features: answers.features,
        existing_bookmakers: answers.existingBookmakers,
      }),
      signal,
    });
    if (!res.ok) {
      const errBody = await res.json().catch(() => ({ error: 'Request failed' }));
      throw new Error((errBody as { error?: string }).error ?? `match: ${res.status}`);
    }
    return res.json();
  }

  claimUrl(path: string): string {
    if (path.startsWith('http')) return path;
    return `${this.baseUrl}${path}`;
  }
}
